import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import CreateBundle from './create'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import RefreshIcon from '@mui/icons-material/Refresh'
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import IndianaScroller from 'react-indiana-drag-scroll'

const BundlesToolbar = (props) => {
  const { selected, add, edit, remove } = props

  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)


  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Paquetes
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title={"Editar Paquete "}>
            <IconButton onClick={edit}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
      <Tooltip title="Añadir Paquete">
        <IconButton onClick={add}>
          <AddIcon />
        </IconButton>
      </Tooltip>
    </Toolbar>
  )
}

const Bundles = () => {
  const app = React.useContext(AppContext)  
  const { current } = app
  const { bundles, detail, remove } = app.bundles
  const [open, setOpen] = React.useState(false)
  const openD = (s) => {
    setOpen(true)
  }
  return (
    <IndianaScroller>
    <Stack>
      <BundlesToolbar selected={current} add={openD} edit={openD} remove={remove}/>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell alignt="left">Nombre</TableCell>
              <TableCell alignt="left">Porcentaje</TableCell>
  						<TableCell alignt="left">Fijo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bundles.map((bundle) => (
              <TableRow
                selected={current && current.id == bundle.id}
                onClick={() => current && current.id == bundle.id?detail(false):detail(bundle)}
                key={bundle.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{bundle.name}</TableCell>
                <TableCell align="left">{bundle.percentage}</TableCell>
                <TableCell align="left">{isNaN(bundle.fixed)?'-':Number(bundle.fixed)/100}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CreateBundle open={open} model={current} close={() => setOpen(false)}/>
    </Stack>
    </IndianaScroller>
  )
}
export default Bundles